import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService{
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  listRoles(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/portalroles');
  }
}
